export default {
  uploadFile: '上传文件',
  uploadTo: ' 上传到',
  fileLink: ' 文件链接',
  upload: '上传',
  addFile: '上传文件',
  fileName: '文件名称',
  delete: '删除',
  fileType: '文件类别',
  url_not_empty: '文件链接',
  category_not_empty: '请选择分类',
  title_not_empty: '文件名称',
  type_note_empty: '请选择文件类别',
  choose_tip: '请先选中文章'
}
